import { type Location } from 'react-router-dom';

import { getSplitLocation } from './stringUtils';

export const getProposalManagementRoute = (
  organizationSlug?: string,
  proposalUid?: string
) => (
  `/org/${organizationSlug}/proposals/${proposalUid}/manage`
);

export const locationShouldShowHeader = (
  location: Location
) => {
  const splitLocation = getSplitLocation(location);
  return (
    !splitLocation.includes('create-proposal') &&
    !splitLocation.includes('edit') &&
    !splitLocation.includes('manage')
  );
};
